// extracted by mini-css-extract-plugin
module.exports = {"container":"OfferTip_container__1KgAR","plain":"OfferTip_plain__29OrZ","tooltip":"OfferTip_tooltip__3kaiL"};